import { motion } from "framer-motion";
import { REVIEWS, BUSINESS } from "../../data/site";
import { Stars } from "./Stars";

export const Reviews = () => {
  return (
    <section id="criticas" data-testid="reviews-section" className="py-24 md:py-32 bg-cream">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        {/* Big metric */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center mb-16 md:mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-end gap-4">
              <span className="font-display font-black text-[26vw] sm:text-[18vw] lg:text-[11vw] leading-[0.8] tracking-tightest">
                {BUSINESS.rating}
              </span>
              <div className="pb-4">
                <Stars count={5} size={26} />
                <p className="font-body text-sm text-[#525252] mt-2">
                  {BUSINESS.reviewCount} críticas no Google
                </p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-7 lg:pl-10">
            <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tightest leading-[0.95]">
              O que dizem as famílias dos nossos patudos.
            </h2>
          </div>
        </div>

        {/* Masonry-ish columns */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {REVIEWS.map((r, idx) => (
            <motion.figure
              key={idx}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (idx % 3) * 0.08 }}
              data-testid={`review-card-${idx}`}
              className="mb-6 break-inside-avoid rounded-[4px] border border-[#0A0A0A] bg-white p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <Stars count={r.stars} size={15} />
              <blockquote className="font-body text-[15px] leading-relaxed text-[#0A0A0A] mt-4">
                &ldquo;{r.text}&rdquo;
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#E20074] text-white font-display font-bold text-sm">
                  {r.name.charAt(0)}
                </span>
                <span>
                  <span className="block font-body font-medium text-sm text-[#0A0A0A]">
                    {r.name}
                  </span>
                  <span className="block font-body text-xs text-[#525252]">
                    Google · {r.when}
                  </span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
